module.exports = __webpack_public_path__ + "img/tu2.68a6b1a8.jpg";